// url normaliser (youtube/vimeo)
function normaliseVideoUrl(url) {
    if (!url) return { platform: null, embedUrl: url };

    const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    if (yt) return { platform: 'youtube', embedUrl: `https://www.youtube.com/embed/${yt[1]}` };

    const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return { platform: 'vimeo', embedUrl: `https://player.vimeo.com/video/${vm[1]}` };

    return { platform: null, embedUrl: url };
}

// connection warmup (optional but snappy)
function preconnectFor(platform) {
    const hosts = {
        youtube: ['https://www.youtube-nocookie.com', 'https://www.youtube.com', 'https://i.ytimg.com', 'https://googlevideo.com'],
        vimeo: ['https://player.vimeo.com', 'https://i.vimeocdn.com', 'https://f.vimeocdn.com']
    }[platform] || [];
    hosts.forEach(href => {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = href;
        link.crossOrigin = '';
        document.head.appendChild(link);
    });
}

// build a player iframe (paused by default)
function createPlayerIframe({ title, platform, embedUrl }) {
    const params = new URLSearchParams();

    // paused preload (no autoplay); API enabled so we can play later without rebuild
    if (platform === 'youtube') {
        params.set('enablejsapi', '1');
        params.set('playsinline', '1');
        params.set('rel', '0');
        params.set('modestbranding', '1');
        params.set('mute', '1');
        params.set('controls', '1');
        params.set('origin', location.origin);
    } else if (platform === 'vimeo') {
        params.set('api', '1');
        params.set('muted', '1');
        params.set('background', '0');
        params.set('title', '0');
        params.set('byline', '0');
        params.set('portrait', '0');
    }

    const src = platform === 'vimeo'
        ? `${embedUrl}?${params.toString()}`.replace('%23t=', '#t=')
        : `${embedUrl}?${params.toString()}`;

    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.setAttribute('title', title || 'video player');
    iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('tabindex', '-1');
    iframe.width = '560';
    iframe.height = '315';
    iframe.dataset.platform = platform;

    iframe.className = 'video-iframe';

    return iframe;
}

function play(iframe) {
    const platform = iframe.dataset.platform;
    if (platform === 'youtube') {
        // unmute then play
        iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'unMute', args: [] }), '*');
        iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*');
    } else if (platform === 'vimeo') {
        // unmute then play
        iframe.contentWindow?.postMessage({ method: 'setVolume', value: 1 }, '*');
        iframe.contentWindow?.postMessage({ method: 'play' }, '*');
    }
}

function initInlineVideo() {
    const videoBlocks = document.querySelectorAll('[data-video-container]');

    videoBlocks.forEach(block => {
        const triggers = block.querySelectorAll('[data-video]');

        const state = new WeakMap();

        const io = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;
                const button = entry.target;
                io.unobserve(button);

                const rawUrl = button.getAttribute('data-video');
                const { platform, embedUrl } = normaliseVideoUrl(rawUrl);
                if (!embedUrl) return;

                const container =
                    button.closest('[data-video-container]') || block;
                if (!container) return;

                preconnectFor(platform);

                const s = state.get(container) || {};
                if (s.loaded) return;

                const iframe = createPlayerIframe({
                    title: button.getAttribute('data-video-title'),
                    platform,
                    embedUrl
                });
                container.appendChild(iframe);
                state.set(container, { loaded: true, iframe });
            });
        }, { root: null, rootMargin: '300px 0px', threshold: 0.01 });

        triggers.forEach((button) => {
            io.observe(button);

            button.addEventListener('click', () => {
                const container =
                    button.closest('[data-video-container]') || block;
                if (!container) return;

                let s = state.get(container);

                if (!s || !s.loaded) {
                    const rawUrl = button.getAttribute('data-video');
                    const { platform, embedUrl } = normaliseVideoUrl(rawUrl);
                    const iframe = createPlayerIframe({
                        title: button.getAttribute('data-video-title'),
                        platform,
                        embedUrl
                    });
                    container.appendChild(iframe);
                    s = { loaded: true, iframe };
                    state.set(container, s);
                }

                const elementsToHide = [
                    ...container.querySelectorAll('[data-video-placeholder], img'),
                    button
                ];
                elementsToHide.forEach(el => el.classList.add('is-fading'));
                const removeAfter = (el) => {
                    el.addEventListener('transitionend', () => el.remove(), { once: true });
                    setTimeout(() => el.isConnected && el.remove(), 400);
                };
                elementsToHide.forEach(removeAfter);

                play(s.iframe);
                s.iframe.focus({ preventScroll: true });
            }, { once: true });
        });
    });
}

document.addEventListener('DOMContentLoaded', initInlineVideo);
